<form #mainForm="ngForm" class="c-form">
	<section class="c-section c-section--open">
	    <div *ngIf="vm.activePolicies?.length > 0" class="c-section__header">
	        <h2 class="c-section__title c-section__title--sm">
	            {{ 'Claim_Request.Claim_For_Damages' | translate }}
	        </h2>
	    </div>
	    <div class="c-section__content">
	        <div class="o-grid o-grid--wrap" [ngClass]="{'o-grid--center-h': vm.activePolicies?.length === 0}">
	            <div *ngIf="vm.activePolicies?.length > 0" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-osb-md u-hidden@up-to-md">
	                <div class="o-graph">
	                    <div class="o-graph__cell">
	                        <div class="o-graph__cell__line o-graph__cell__line--blue"></div>
	                        <div class="o-graph__cell__circle o-graph__cell__circle--blue"
	                             [ngClass]="{'o-graph__cell__circle--blue--filled': vm.step > 1}"></div>
	                        <div class="c-text c-text--lg u-osb-md">{{ 'Claim_Request.Case_Description' | translate }}</div>
	                    </div>
	                    <div class="o-graph__cell">
	                        <div class="o-graph__cell__line"
	                             [ngClass]="{'o-graph__cell__line--blue': vm.step > 1}"></div>
	                        <div class="o-graph__cell__circle"
	                             [ngClass]="{'o-graph__cell__circle--blue': vm.step > 1, 'o-graph__cell__circle--blue--filled': vm.step > 2}"></div>
	                        <div class="c-text c-text--lg u-osb-md">{{ 'Claim_Request.Upload_Invoices' | translate }}</div>
	                    </div>
	                    <div class="o-graph__cell">
	                        <div class="o-graph__cell__line"
	                             [ngClass]="{'o-graph__cell__line--blue': vm.step > 2}"></div>
	                        <div class="o-graph__cell__circle"
	                             [ngClass]="{'o-graph__cell__circle--blue': vm.step > 2, 'o-graph__cell__circle--blue--filled': vm.step > 3}"></div>
	                        <div class="c-text c-text--lg u-osb-md">{{ 'Claim_Request.Reimbursement_Information' | translate
	                            }}
	                        </div>
	                    </div>
	                    <div class="o-graph__cell">
	                        <div class="o-graph__cell__circle"
	                             [ngClass]="{'o-graph__cell__circle--blue': vm.step > 3, 'o-graph__cell__circle--blue--filled': vm.step > 4}"></div>
	                        <div class="c-text c-text--lg u-osb-md">{{ 'Claim_Request.Contact_Details' | translate }}</div>
	                    </div>
	                </div>
	                <div class="u-hidden@up-to-md" style="margin-top: 32px" *ngIf="vm.caseDescription?.policyUser">
	                    <p class="c-text c-text--lg u-osb-md">
	                       {{ vm.getContactUsInfo() }}
	                    </p>
	                </div>
	            </div>
	            <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-75@md-and-up u-osb-md">
	                <div class="c-card c-card--height-fit">
	                    <div class="c-content c-content--xxl">
	                        <div class="o-grid o-grid--center-h o-grid--wrap">
	                            <div *ngIf="vm.step < 5"
	                                 class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@lg-and-up">
	                                <div class="u-osb-lg">
	                                        <h1 *ngIf="vm.step === 1 && vm.activePolicies?.length > 0" class="c-card__title u-hidden@up-to-md">{{
	                                            'Claim_Request.Case_Description' | translate }}</h1>
	                                        <h1 *ngIf="vm.step === 2" class="c-card__title u-hidden@up-to-md">{{
	                                            'Claim_Request.Upload_Invoices' | translate }}</h1>
	                                        <h1 *ngIf="vm.step === 3" class="c-card__title u-hidden@up-to-md">{{
	                                            'Claim_Request.Reimbursement_Information' | translate }}</h1>
	                                        <h1 *ngIf="vm.step === 4" class="c-card__title u-hidden@up-to-md">{{
	                                            'Claim_Request.Contact_Details' | translate }}</h1>
	                                    <div style="display: flex; align-items: baseline;">
	                                         <span id="backArrowButton" class="u-hidden@md-and-up"
	                                               style="margin-right: 10px"
	                                               *ngIf="vm.step > 1 && vm.step <= 4"
	                                               (click)="vm.previousStep()">
	                                             <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icons/icon-back-arrow.svg" style="height: 15px; width: 15px;">
	                                        </span>
	                                    <h1 style="margin: 22px 0" *ngIf="vm.step === 1"
	                                        class="c-card__title u-hidden@md-and-up">1/4 {{ 'Claim_Request.Case_Description'
	                                        | translate }}</h1>
	                                    <h1 style="margin: 22px 0" *ngIf="vm.step === 2"
	                                        class="c-card__title u-hidden@md-and-up">2/4 {{ 'Claim_Request.Upload_Invoices'
	                                        | translate }}</h1>
	                                    <h1 style="margin: 22px 0" *ngIf="vm.step === 3"
	                                        class="c-card__title u-hidden@md-and-up">3/4 {{
	                                        'Claim_Request.Reimbursement_Information' | translate }}</h1>
	                                    <h1 style="margin: 22px 0" *ngIf="vm.step === 4"
	                                        class="c-card__title u-hidden@md-and-up">4/4 {{ 'Claim_Request.Contact_Details'
	                                        | translate }}</h1>
	                                    </div>
	                                    <div *ngIf="vm.activePolicies?.length === 0" class="c-text--center u-osb-sm u-osb-md">
	                                        <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/umbrella_image.svg">
	                                        <div id="noActiveInsuranceLabel" class="c-text c-text--lg" style="margin: 22px 0">
	                                            {{'Claim_Request.No_Active_Insurance' | translate}}
	                                        </div>
	                                    </div>
	
	                                    <div name="vm.caseDescriptionForm"
	                                             *ngIf="vm.step === 1 && vm.activePolicies?.length > 0"
	                                             id="caseDescriptionForm">
	                                        <div class="c-form__group u-osb-sm u-osb-md">
	                                            <label for="policyUser" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Insurance_Policy' | translate }} *
	                                            </label>
	                                            <mat-select id="policyUser"
	                                                       name="policyUser"
	                                                       *ngIf="vm.activePolicies"
	                                                       class="mat-select mat-select--border"
	                                                       [(value)]="vm.caseDescription.policyUser"
	                                                       (selectionChange)="vm.checkClaimsSupported()">
	                                                <mat-option *ngFor="let policy of vm.activePolicies ; let $index=index"
	                                                           [value]="policy">
	                                                    {{ policy.policyNumber }} {{ policy.displayName }}
	                                                </mat-option>
	                                            </mat-select>
	                                            <p id="claimsNotSupportedLabel" class="c-text c-text--sm c-text--s3" *ngIf="vm.claimsNotSupported">
	                                                {{ 'Claim_Request.Properties.Insurance_Policy_Claims_Not_supported' | translate }}
	                                            </p>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md" *ngIf="vm.initialized" 
	                                             [ngClass]="{'c-form__group--error': vm.caseDescriptionSubmitted && !vm.caseDescription.treatmentDate }">
	                                            <label class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Treatment_Date' | translate }} *
	                                            </label>
	                                            <div *ngIf="!vm.isProcessing">
	                                                <input-datepicker-new id="treatmentDate"
	                                                    name="treatmentDate"
	                                                    [(model)]="vm.caseDescription.treatmentDate"
	                                                    [startDate]="vm.caseDescription.treatmentDate"
	                                                    [minDate]="vm.minDate"
	                                                    [hasTimepicker]="false"
	                                                    [hasCalendarIcon]="true"
	                                                    [isSingleDate]="true"
	                                                    [isRequired]="true"></input-datepicker-new>
	                                            </div>
	                                            <item-form-error
	                                                    *ngIf="vm.caseDescriptionSubmitted && !vm.caseDescription.treatmentDate"
	                                                    [fieldName]="'Claim_Request.Properties.Treatment_Date' | translate"
	                                                    [error]="{'required':true}"></item-form-error>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md"
	                                             [ngClass]="{'c-form__group--error': (vm.caseDescriptionSubmitted || sumRequested.dirty) && sumRequested.invalid }">
	                                            <label for="sumRequested" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Sum_Requested' | translate }} *
	                                            </label>
	                                            <input type="number"
	                                                   id="sumRequested"
	                                                   name="sumRequested"
	                                                   #sumRequested="ngModel"
	                                                   [(ngModel)]="vm.caseDescription.sumRequested"
	                                                   class="c-form__input" required>
	                                            <item-form-error
	                                                    *ngIf="(vm.caseDescriptionSubmitted || sumRequested.dirty) && sumRequested.invalid"
	                                                    [fieldName]="'Claim_Request.Properties.Sum_Requested' | translate"
	                                                    [error]="sumRequested.errors"></item-form-error>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md">
	                                            <label for="treatmentDescription" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Description_Of_Service' | translate }}
	                                            </label>
	                                            <textarea id="treatmentDescription"
	                                                      name="treatmentDescription"
	                                                      #treatmentDescription="ngModel"
	                                                      [(ngModel)]="vm.caseDescription.treatmentDescription"
	                                                      class="c-form__input" cols="3" maxlength="255">
	                                            </textarea>
	                                        </div>
	                                    </div>
	
	                                    <div *ngIf="vm.step === 2"
	                                             name="vm.fileUploadForm"
	                                             id="fileUploadForm"
	                                             class="c-form">
	                                        <div class="c-form__group u-osb-sm u-osb-md">
	                                            <item-notification icon="attention"
	                                                               [text]="'Claim_Request.Properties.Upload_Info_Box' | translate"
	                                                               [theme]="5"></item-notification>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md">
	                                            <div (click)="vm.triggerFileSelectionDialog()"
	                                                 class="c-file_upload u-osb-sm u-osb-md">
	                                                <div class="c-file_upload__item">
	                                                    <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/pin.svg">
	                                                </div>
	                                                <div class="c-file_upload__item">
	                                                    <div class="c-text c-text--md">
	                                                        {{ 'Claim_Request.Properties.Upload_Invoice' | translate }}
	                                                    </div>
	                                                </div>
	                                            </div>
	                                            <input id="fileInput"
	                                            	name="fileInput"
													[(ngModel)]="vm.file"
													type="file"
													[fileChange]="vm.uploadFile"
													accept=".pdf,.ddoc,.bdoc,.ddoc,.asice,.png,.jpg,.jpeg,.doc,.docx,.rft"
													style="display: none">
	                                            <div>
	                                                <div *ngFor="let file of vm.fileUpload.files ; let $index=index" class="c-file_item">
	                                                    {{file.fileName}}
	                                                    <div class="c-file_item__remove">
	                                                        <a id="deleteFileButton{{$index}}" href="javascript:void(0)" (click)="vm.deleteFile(file)">
	                                                            <i class="o-icon o-icon--x u-no-mr" style="color: red"></i>
	                                                        </a>
	                                                    </div>
	                                                </div>
	                                            </div>
	                                        </div>
	                                    </div>
	
	                                    <div *ngIf="vm.step === 3"
	                                             name="vm.paymentDetailsForm"
	                                             id="paymentDetailsForm"
	                                             class="c-form">
	                                        <div class="c-form__group u-osb-sm u-osb-md"
	                                             [ngClass]="{'c-form__group--error': (vm.paymentDetailsSubmitted || accountHolderName.dirty) && accountHolderName.invalid }">
	                                            <label for="accountHolderName" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Bank_Account_Holder' | translate }} *
	                                            </label>
	                                            <input type="text"
	                                                   id="accountHolderName"
	                                                   name="accountHolderName"
	                                                   #accountHolderName="ngModel"
	                                                   [(ngModel)]="vm.paymentDetails.accountHolderName"
	                                                   maxlength="255"
	                                                   class="c-form__input" required>
	                                            <item-form-error
	                                                    *ngIf="(vm.paymentDetailsSubmitted || accountHolderName.dirty) && accountHolderName.invalid"
	                                                    [fieldName]="'Claim_Request.Properties.Bank_Account_Holder' | translate"
	                                                    [error]="accountHolderName.errors"></item-form-error>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md"
	                                             [ngClass]="{'c-form__group--error': (vm.paymentDetailsSubmitted || accountNumber.dirty) && accountNumber.invalid }">
	                                            <label for="accountNumber" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Bank_Account_Number' | translate }} *
	                                            </label>
	                                            <input type="text"
	                                                   id="accountNumber"
	                                                   name="accountNumber"
	                                                   #accountNumber="ngModel"
	                                                   [(ngModel)]="vm.paymentDetails.accountNumber"
	                                                   maxlength="255"
	                                                   class="c-form__input" required>
	                                            <item-form-error
	                                                    *ngIf="(vm.paymentDetailsSubmitted || accountNumber.dirty) && accountNumber.invalid"
	                                                    [fieldName]="'Claim_Request.Properties.Bank_Account_Number' | translate"
	                                                    [error]="accountNumber.errors"></item-form-error>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md"
	                                             [ngClass]="{'c-form__group--error': (vm.paymentDetailsSubmitted || bankName.dirty) && bankName.invalid }">
	                                            <label for="bankName" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Bank_Name' | translate }} *
	                                            </label>
	                                            <input type="text"
	                                                   id="bankName"
	                                                   name="bankName"
	                                                   #bankName="ngModel"
	                                                   [(ngModel)]="vm.paymentDetails.bankName"
	                                                   maxlength="255"
	                                                   class="c-form__input" required>
	                                            <item-form-error
	                                                    *ngIf="(vm.paymentDetailsSubmitted || bankName.dirty) && bankName.invalid"
	                                                    [fieldName]="'Claim_Request.Properties.Bank_Name' | translate"
	                                                    [error]="bankName.errors"></item-form-error>
	                                        </div>
	                                        <!--<div class="c-form__group u-osb-sm u-osb-md"
	                                             [ngClass]="{'c-form__group--error': (vm.paymentDetailsSubmitted || sumRequested.dirty) && sumRequested.invalid }">
	                                            <label for="sumRequested" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Sum_For_Reimbursement' | translate }} *
	                                            </label>
	                                            <input type="number"
	                                                   id="sumRequested"
	                                                   name="sumRequested"
	                                                   #sumRequested="ngModel"
	                                                   [(ngModel)]="vm.paymentDetails.sumRequested"
	                                                   class="c-form__input" required>
	                                            <item-form-error
	                                                    *ngIf="(vm.paymentDetailsSubmitted || sumRequested.dirty) && sumRequested.invalid"
	                                                    [fieldName]="'Claim_Request.Properties.Sum_For_Reimbursement' | translate"
	                                                    [error]="sumRequested.errors"></item-form-error>
	                                        </div>-->
	                                    </div>
	
	                                    <div *ngIf="vm.step === 4"
	                                             name="vm.contactDetailsForm"
	                                             id="contactDetailsForm"
	                                             class="c-form">
	                                        <div class="c-form__group u-osb-sm u-osb-md"
	                                             [ngClass]="{'c-form__group--error': (vm.contactDetailsSubmitted || contactEmail.dirty) && contactEmail.invalid }">
	                                            <label for="contactEmail" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Insurance_Policy_Owner_Email' | translate }} *
	                                            </label>
	                                            <input type="text"
	                                                   id="contactEmail"
	                                                   name="contactEmail"
	                                                   #contactEmail="ngModel"
	                                                   [(ngModel)]="vm.contactDetails.contactEmail"
	                                                   maxlength="64"
	                                                   class="c-form__input" required>
	                                            <item-form-error
	                                                    *ngIf="(vm.contactDetailsSubmitted || contactEmail.dirty) && contactEmail.invalid"
	                                                    [fieldName]="'Claim_Request.Properties.Insurance_Policy_Owner_Email' | translate"
	                                                    [error]="contactEmail.errors"></item-form-error>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md"
	                                             [ngClass]="{'c-form__group--error': (vm.contactDetailsSubmitted || contactPhone.dirty) && contactPhone.invalid }">
	                                            <label for="contactPhone" class="c-form__label c-form__label">
	                                                {{ 'Claim_Request.Properties.Insurance_Policy_Owner_Phone' | translate
	                                                }} *
	                                            </label>
	                                            <input type="text"
	                                                   id="contactPhone"
	                                                   name="contactPhone"
	                                                   #contactPhone="ngModel"
	                                                   [(ngModel)]="vm.contactDetails.contactPhone"
	                                                   maxlength="64"
	                                                   class="c-form__input" required>
	                                            <item-form-error
	                                                    *ngIf="(vm.contactDetailsSubmitted || contactPhone.dirty) && contactPhone.invalid"
	                                                    [fieldName]="'Claim_Request.Properties.Insurance_Policy_Owner_Phone' | translate"
	                                                    [error]="contactPhone.errors"></item-form-error>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md"
	                                        	[ngClass]="{'c-form__group--error': (vm.contactDetailsSubmitted || consent1.dirty) && consent1.invalid }">
	                                            <label class="c-checkbox">
	                                                <input type="checkbox" 
														name="consent1"
														#consent1="ngModel"
														[(ngModel)]="vm.contactDetails.consentsAccepted.consent1"
														required>
	                                                <span id="claimsConsent1Label">
	                                                    {{ 'Claim_Request.Properties.Consent_One' | translate }}
	                                                </span>
	                                            </label>
	                                        </div>
	                                        <div class="c-form__group u-osb-sm u-osb-md"
	                                        	[ngClass]="{'c-form__group--error': (vm.contactDetailsSubmitted || consent2.dirty) && consent2.invalid }">
	                                            <label class="c-checkbox">
	                                                <input type="checkbox" 
	                                                	name="consent2"
	                                                	#consent2="ngModel"
														[(ngModel)]="vm.contactDetails.consentsAccepted.consent2"
														required>
	                                                <span id="claimsConsent2Label">
	                                                    {{ 'Claim_Request.Properties.Consent_Two' | translate }}
	                                                </span>
	                                            </label>
	                                        </div>
	                                    </div>
	                                    <div class="o-grid o-grid--bottom o-grid--wrap u-osb-lg"
	                                         [ngClass]="{'o-grid--center-h': vm.activePolicies?.length === 0}">
	                                    	<div *ngIf="vm.activePolicies?.length > 0" class="o-grid__cell o-grid__cell--w-fixed u-no-p u-ost-md u-hidden@up-to-md">
		                                    	<button id="backButton"
	                                                    *ngIf="vm.step > 1 && vm.step <= 4"
		                                                (click)="vm.previousStep()"
		                                                class="c-button c-button--s1 c-form__button"
		                                                type="button">
		                                            {{ 'Common.Back' | translate }}
		                                        </button>
	                                    	</div>
	                                    	<div *ngIf="vm.activePolicies?.length > 0" class="o-grid__cell u-no-p"></div>
	                                    	<div class="o-grid__cell o-grid__cell--w-fixed u-no-p u-ost-md">
		                                    	<button id="nextStepButton" 
	                                                    *ngIf="vm.step <= 4"
		                                                [disabled]="vm.step === 4 && !vm.isConsentChecked()"
		                                                (click)="vm.submitCurrentStep(mainForm)"
		                                                class="c-button c-button--s1 c-form__button"
		                                                type="button">
		                                            {{ (vm.step === 4 ? 'Modal.Title.Confirm' : 'Booking.Button.Next') |
		                                            translate }}
		                                        </button>
	                                    	</div>
	                                    </div>
	                                    <loader-overlay *ngIf="!vm.isInitialized || vm.isProcessing"></loader-overlay>
	                                </div>
	                            </div>
	                            <div *ngIf="vm.step === 5"
	                                 class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-90@lg-and-up">
	                                <div class="u-osb-lg">
	                                    <div class="c-text--center u-osb-md">
	                                        <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/checkmark.svg">
	                                    </div>
	                                    <h1 id="claimsFinalStepTitle" class="c-card__title">
	                                        {{ 'Claim_Request.Properties.Final_Stage_Title' | translate }}
	                                    </h1>
	                                    <div id="claimsFinalStepDescription"  class="c-text c-text--lg u-osb-md">
	                                        {{ 'Claim_Request.Properties.Final_Stage_Description' | translate }}
	                                    </div>
	                                    <div class="c-form__group u-osb-sm u-osb-md">
	                                        <button id="goToClaimListButton" (click)="vm.goToClaimList()"
	                                                class="c-button c-button--s1 c-form__button">
	                                            {{ 'Booking.Button.Next' | translate }}
	                                        </button>
	                                    </div>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</section>
	<div class="u-hidden@md-and-up" style="padding: 16px" *ngIf="vm.caseDescription?.policyUser">
	    <p class="c-text c-text--sm u-osb-md">
	        {{ vm.getContactUsInfo() }}
	    </p>
	</div>
</form>
